/**
 * Picks v2 or v1 of the Quick Taps page based on the redesign flag.
 * Same pattern as the other Switch components.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import QuickTapsPage   from './QuickTapsPage';
import QuickTapsPageV2 from './QuickTapsPageV2';

export default function QuickTapsPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? QuickTapsPageV2 : QuickTapsPage;
  return <Component {...props} />;
}
